import axios from "axios";
import { pageRoutes } from "src/constants";

// Full page load (not router navigation) so in-memory Redux state is cleared along with the session
export const logoutAndRedirectToLogin = () => {
  localStorage.clear();
  window.location.replace(pageRoutes.LOGIN);
};

export const headers = (token) => {
  if (token) {
    return {
      Accept: "application/json",
      "Content-Type": "application/json",
      "x-access-token": token,
    };
  }

  return {
    Accept: "application/json",
    "Content-Type": "application/json",
  };
};

export const reusableFetch = async (
  url,
  method,
  data,
  rejectWithValue,
  isArrayBuffer
) => {
  const token = localStorage.token;

  try {
    const response = await axios({
      url: `${process.env.REACT_APP_API_URL}/${url}`,
      method: method,
      responseType: isArrayBuffer ? "arraybuffer" : "json",
      headers: headers(token),
      data: data ? data : {},
    });
    
    return response; // Assuming the relevant data is returned from the API
  } catch (error) {
    if (error?.response?.status === 401) {
      logoutAndRedirectToLogin();
    }
    return rejectWithValue(error?.response ? error.response.data : error);
  }
};
